import React from "react";
import { Check, Mic, MicOff, Trash2, Upload } from "lucide-react";
import { Button, Modal, Box, Typography, CircularProgress } from "@mui/material";
import AudioPlayerForRouting from "../reusables/AudioPlayerForRouting";

const NewRecordingModal = ({
  open,
  setOpen,
  recordingData,
  setRecordingData,
  setRecordType,
  recordType,
  handleFileUpload,
  handleClick,
  buttonState,
  formatTime,
  time,
  maxTime,
  restartRecording,
  storeRecording,
  snackMsg,
  setSnackMsg,
  openSnack,
  setOpenSnack,
  fileInputRef,
  isRecording,
  uploadedFile,
  isConverting,
  setUploadedFile,
  audioPreviewUrl,
  step, setStep
}) => {
 

  return (
    <Modal
     BackdropProps={{
        style: { backgroundColor: "rgb(144,150,160,0.8)" },
      }}
     open={open} onClose={() =>{
        setUploadedFile(null)
        setRecordingData(null)
        setStep(1)
     setOpen(false)}}>
      <Box className="bg-white rounded-xl w-[95%] sm:w-[420px] mx-auto mt-[12vh] p-6 space-y-5 shadow-xl">
        {/* Header */}
       {step !==3&& (
        <div className="flex justify-between items-center">
          <Typography className="text-[17px] font-bold text-gray-800" sx={{fontSize:'20px', fontWeight:700}}>
            {step === 1 ? "New Recording" : "Record Audio"}
          </Typography>
          <button
            onClick={() => 
                {
        setUploadedFile(null)
        setRecordingData(null)
        setStep(1)
     setOpen(false)}}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>
       )}

        {/* Step 1 - Choose recording method */}
        {step === 1 && (
          <div className="space-y-5">
            {/* Recording Name Input */}
            <div>
              <div className="text-[13px] text-gray-600 mb-1">
                Recording Name
              </div>
              <input
                placeholder="Enter recording name"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm outline-none focus:border-indigo-500"
                value={recordingData?.title}
                onChange={(e) =>
                  setRecordingData({
                    ...recordingData,
                    title: e.target.value,
                  })
                }
              />
            </div>

            {/* Recording Method */}
            <div>
              <div className="text-[13px] text-gray-600 mb-2">
                Recording Method
              </div>

              <div className="space-y-3">
                <div
                  onClick={() => setRecordType("record_now")}
                  className={`flex items-center border cursor-pointer rounded-lg p-3 transition ${
                    recordType === "record_now"
                      ? "border-2 border-[#6366F1] bg-indigo-50"
                      : "border-gray-200"
                  }`}
                >
                  <div className="bg-indigo-100 text-indigo-600 p-2 rounded-md">
                    <Mic size={18} />
                  </div>
                  <div className="ml-3">
                    <div className="text-[14px] font-medium text-gray-800">
                      Record Live
                    </div>
                    <div className="text-[12px] text-gray-500">
                      Record using your microphone
                    </div>
                  </div>
                </div>

                <div
                  onClick={() => setRecordType("upload_mp3")}
                  className={`flex items-center border cursor-pointer rounded-lg p-3 transition ${
                    recordType === "upload_mp3"
                      ? "border-2 border-[#6366F1] bg-indigo-50"
                      : "border-gray-200"
                  }`}
                >
                  <div className="bg-gray-100 text-gray-600 p-2 rounded-md">
                    <Mic size={18} />
                  </div>
                  <div className="ml-3">
                    <div className="text-[14px] font-medium text-gray-800">
                      Upload File
                    </div>
                    <div className="text-[12px] text-gray-500">
                      Upload an audio file
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end space-x-2 pt-2">
              <Button
                onClick={() => setOpen(false)}
                sx={{
                  textTransform: "none",
                  color: "#414B5A",
                  fontSize: "14px",
                  border : '1px solid #D1D5DB',
                  fontWeight:510
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  if (!recordingData.title) {
                    setSnackMsg("Please enter a recording name first");
                    setOpenSnack(true);
                  } else {
                    setStep(2);
                  }
                }}
                variant="contained"
                color="primary"
                sx={{
                  fontSize: "14px",
                  fontWeight:510
                }}
              >
                Next
              </Button>
            </div>
          </div>
        )}

        {/* Step 2 - Record UI */}
        {step === 2 && (
          <>
            {recordType === "record_now" ? (
              <div className="text-center space-y-7">
                <div className="mb-3">
                  <Typography className="text-[16px] font-semibold text-gray-800">
                    {recordingData.title || "Record Audio"}
                  </Typography>
                  <div className="text-[15px] text-gray-500">
                    Record your audio message
                  </div>
                </div>
                {/* Mic button */}
                {buttonState == "play" && audioPreviewUrl && (
                  <div className="flex items-center justify-center gap-2 w-full">
                    <div className="flex-1 min-w-0">
                      <AudioPlayerForRouting src={audioPreviewUrl} compact />
                    </div>
                    <button
                      onClick={restartRecording}
                      className="w-10 h-10 rounded-full flex items-center justify-center cursor-pointer transition bg-[#FDCACA] shrink-0"
                    >
                      <Trash2 size={18} className="text-[#DC2627]" />
                    </button>
                  </div>
                )}

                {buttonState == "stop" && (
                  <div
                    onClick={handleClick}
                    className={`w-20 h-20 rounded-full mx-auto flex items-center justify-center cursor-pointer transition bg-red-500
              `}
                  >
                    <MicOff size={32} className="text-white" />
                  </div>
                )}

                {buttonState == "record" && (
                  <div
                    onClick={handleClick}
                    className={`w-20 h-20 rounded-full mx-auto flex items-center justify-center cursor-pointer transition bg-indigo-500
              `}
                  >
                    <Mic size={32} className="text-white" />
                  </div>
                )}

                {buttonState == "recording" && (
                  <div
                    onClick={handleClick}
                    className={`w-20 h-20 rounded-full mx-auto flex items-center justify-center cursor-pointer transition bg-red-500
              `}
                  >
                    <Mic size={32} className="text-white" />
                  </div>
                )}

                {/* Timer */}
                {buttonState != "play" && (
                  <>
                    <Typography
                      className="font-mono text-[18px] tracking-wide text-black"
                      sx={{ mt: 1 }}
                    >
                      {formatTime(time)}/{formatTime(maxTime)}
                    </Typography>
                    <Typography className="text-[13px] text-gray-500">
                      {buttonState == "play" && "Click to listen to recording"}
                      {buttonState == "recording" &&
                        "Click to listen to recording"}
                      {buttonState == "record" && "Click to start recording"}
                      {buttonState == "stop" && "Click to stop recording"}
                    </Typography>
                  </>
                )}

                {/* Footer Buttons */}
                <div className="flex justify-between pt-4">
                  <Button
                    onClick={() => setStep(1)}
                    sx={{
                        textTransform: "none",
                  color: "#414B5A",
                  fontSize: "14px",
                  border : '1px solid #D1D5DB',
                  fontWeight:510
                    }}
                  >
                    Back
                  </Button>
                  <div className="flex space-x-2">
                    <Button
                      onClick={() => {
                        restartRecording();
                        setOpen(false);
                      }}
                      sx={{
                        textTransform: "none",
                  color: "#414B5A",
                  fontSize: "14px",
                  border : '1px solid #D1D5DB',
                  fontWeight:510
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        if (recordingData.title.length < 1) {
                          setSnackMsg("no record title");
                          setOpenSnack(true);
                        } else {
                          storeRecording();
                        }
                      }}
                      sx={{
                        fontSize: "14px",
                        fontWeight:510
                      }}
                    >
                      Save Recording
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center space-y-7 w-full">
                <div className="mb-3">
                  <Typography className="text-[16px] font-semibold text-gray-800">
                    {recordingData.title}
                  </Typography>
                  <div className="text-[15px] text-gray-500">
                    Upload your audio file
                  </div>
                </div>
                <div className="relative inline-block w-full">
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileUpload}
                    accept="audio/*"
                    className="hidden"
                    disabled={isRecording || isConverting}
                  />

                  {uploadedFile ? (
                    <div className="flex flex-col items-center justify-center space-y-4 pb-10 pt-5">
                      {audioPreviewUrl ? (
                        <div className="flex items-center justify-center gap-2 w-full">
                          <div className="flex-1 min-w-0">
                            <AudioPlayerForRouting src={audioPreviewUrl} compact />
                          </div>
                          <button
                            onClick={restartRecording}
                            className="w-10 h-10 rounded-full flex items-center justify-center cursor-pointer transition bg-[#FDCACA] shrink-0"
                          >
                            <Trash2 size={18} className="text-[#DC2627]" />
                          </button>
                        </div>
                      ) : (
                        <div className="flex items-center gap-3 py-4">
                          <CircularProgress size={24} />
                          <span className="text-sm text-gray-600">Converting audio...</span>
                        </div>
                      )}
                    </div> 
                  ) : (
                    <div
                      onClick={() => fileInputRef.current?.click()}
                      className="flex cursor-pointer flex-col items-center my-auto justify-center  space-y-2  border-[1px] border-dashed border-gray-300 rounded-lg p-4 py-10  w-[100%] mx-auto"
                    >
                      <Upload size={30} className="text-gray-500 mr-2 " />
                      <div className="text-[15px]">
                        Click to upload audio file
                      </div>
                      <div className="text-[13px] text-[#6B7280]">
                        Supports MP3, WAV, M4A files
                      </div>
                    </div>
                  )}

                  {/* <div className="lg:text-[14px] text-[13px] italic ">
                    {" "}
                    {uploadedFile ? uploadedFile.name : "No file uploaded"}{" "}
                  </div> */}

                  {/* Footer Buttons */}
                  <div className="flex justify-between pt-4">
                    <Button
                      onClick={() => setStep(1)}
                      sx={{
                        textTransform: "none",
                  color: "#414B5A",
                  fontSize: "14px",
                  border : '1px solid #D1D5DB',
                  fontWeight:510
                      }}
                    >
                      Back
                    </Button>
                    <div className="flex space-x-2">
                      <Button
                        onClick={() => {
                          setUploadedFile(null);
                          setOpen(false);
                        }}
                        sx={{
                            textTransform: "none",
                  color: "#414B5A",
                  fontSize: "14px",
                  border : '1px solid #D1D5DB',
                  fontWeight:510
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          if (recordingData.title.length < 1) {
                            setSnackMsg("no record title");
                            setOpenSnack(true);
                          } else {
                            storeRecording();
                          }
                        }}
                        sx={{
                          fontSize: "14px",
                          fontWeight:510
                        }}
                      >
                        Save Recording
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {step == 3 && (
             <div className="lg:px-8 px-4 py-14 space-y-2">
                   
            
            
                  <div className="flex justify-center ">
                  <div className="bg-[#DCFCE7] rounded-full py-4 px-4 text-[23px]"><Check/></div>
                  </div>
            
            
                  <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mt-4">Recording Saved!</div>
            
            
                    
                  <div className="lg:text-[15px] text-[rgb(78,88,101)]  text-[13px]   text-center mt-1 mb-6">Your recording "{recordingData.title}" has been saved successfully.</div>
            
            
                    
            
                  
                  </div>
        )} 
      </Box>
    </Modal>
  );
};

export default NewRecordingModal;
